var map = {
	"./1708634310245.png": 83691,
	"./Extended-Supply-Chain-Optimization-Img1.png": 90147,
	"./Extended_Supply_Chain_Optimization_Section_2_Image-01.png": 32969,
	"./Group 1171277621 (1).png": 54197,
	"./Group 1171277621.png": 77063,
	"./Group 1171277622 (1).png": 69822,
	"./Group 1171277622.png": 26380,
	"./Group 1171277623 (1).png": 74179,
	"./Group 1171277623.png": 38005,
	"./Group 1171277624.png": 69594,
	"./Group 1171277625.png": 59427,
	"./Group 1171277626.png": 97448,
	"./Make_the-Connection-to-the_Business-01-01.png": 71269,
	"./Organizations-hunger-to-save-money_Inforgraphic-02.webp": 42436,
	"./hero-section-extended-supply.png": 25371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10759;